export const CART_MESSAGES = {
    CHECKOUT_PREPARE_ERROR:
        "An error occurred while preparing your checkout. Please try again.",
    REMOVED_ALL: "Products have been removed from the cart.",
    REMOVE_ALL_FAILED: "Failed to remove products from the cart.",
    REMOVE_ALL_ERROR: "Error removing products from the cart.",
    MOV_NOT_MET_ERROR:
        "Minimum Order Value (MOV) not met for one or more suppliers. Please adjust your cart to proceed.",
    CONSOLIDATED_FEED_MOV_NOT_MET_ERROR:
        "Add more products to reach the consolidated feed minimum order value before checkout.",
    STOCK_ISSUES_ERROR:
        "Some products are out of stock or exceed available stock. Please adjust quantities to proceed.",
} as const;

export const CART_REFETCH_QUERIES = ["GetActiveOrder"] as const;

export const CART_DEBOUNCE_MS = 300;

export const CART_REMOVE_SUCCESS_RELOAD_DELAY_MS = 150;
